import Vue from 'vue';
const {
  $gettext
} = Vue.prototype;
export default {
  defaultEntity: {
    companyName: '',
    activity: '',
    civility: '',
    fullname: '',
    phone: '',
    email: '',
  },
  layout() {
    const {
      state
    } = Vue.prototype.store;
    const {
      rules
    } = state.toggle;
    return [
      {
        fieldName: 'civility',
        type: 'radio',
        label: $gettext('Civility'),
        isTwoColum: true,
        items: [
          {
            id: 0,
            name: $gettext('Mr.'),
          },
          {
            id: 1,
            name: $gettext('Ms.'),
          },
        ],
        itemValue: 'id',
        itemText: 'name',
        class: 'full radio-col-4 mb-1',
      },
      {
        isTwoColum: true,
        fieldName: 'companyName',
        label: $gettext('Company Name'),
      },
      {
        isTwoColum: true,
        fieldName: 'activity',
        label: $gettext('Field of activity'),
      },

      {
        isTwoColum: true,
        fieldName: 'fullname',
        label: $gettext('Fullname'),
        rules: [rules.required]
      },
      {
        isTwoColum: true,
        fieldName: 'phone',
        label: $gettext('Telephone'),
        rules: [rules.required]
      },
      {
        isTwoColum: true,
        fieldName: 'email',
        label: $gettext('Email'),
        rules: [rules.required, rules.email]
      },
    ];
  }
};